/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */

// Uses Webpack to hide the development version from production

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./store/store.prod');
} else {
  module.exports = require('./store/store.dev');
}
